export default __webpack_public_path__ + "img/ca2cfbf9c070451c7da615bb557d4328.png";